<div class="content"> 
  <br>

<h4 style="margin-left: 20px;">Materials</h4> 

<span style="margin-left: 10px;">
  <button mat-raised-button class="success" (click)="openProjectMaterialAdd()" *ngIf="!showAvailbleMaterials">
    <mat-icon class="mr">add</mat-icon>Add Materials
  </button>

  <!-- CSV import controls -->
  <input type="file" accept=".csv" (change)="onMaterialsCsvSelected($event)" style="margin-left:12px" />
  <button mat-button color="primary" (click)="uploadMaterialsCsv()" [disabled]="!selectedMaterialsCsv">Upload CSV</button>
  <button mat-button color="primary" (click)="downloadProjectMaterialsSampleCsv()" style="margin-left:8px;">
    <mat-icon class="mr">file_download</mat-icon>Sample CSV
  </button>

  <button mat-button color="success" (click)="toggleAvailbleMaterials()" *ngIf="showAvailbleMaterials">
    <mat-icon class="mr">menu</mat-icon>Done
  </button>
</span>
<br><br>
<span *ngIf="!isMobile"> 
 <span *ngIf="!showAvailbleMaterials">
<mat-table *ngIf="dataSource" [dataSource]="dataSource" style="width: 100%;"  >

  
  <ng-container *ngFor="let column of ProjectMaterialColumns" [matColumnDef]="column">

    <th mat-header-cell *matHeaderCellDef style="width: 700px; text-transform: uppercase; text-align: center;" ><span *ngIf="column != 'edit'"></span> <a (click)="sortByProjectMaterial(column)">{{ columnDisplayNames[column] || column }}</a> </th> 
    <!-- <mat-header-cell *matHeaderCellDef>
  
  <td>{{ column }}</td>
  </mat-header-cell>  -->
<!-- <mat-cell *matCellDef="let element">{{ element[column] }}</mat-cell>  -->

<td mat-cell *matCellDef="let element" style="text-align: center;">
  <div *ngIf="element !== editedRow; else editCell">

 <span  *ngIf="column == 'total'" style="text-align: center;"> 
      <p>{{ element.purchasedTotal| currency  }}  of {{ element.cost| currency  }} </p>
      <div class="progress-bar-container">
        <div class="progress-bar" [style.width.%]="(element.purchasedTotal / element.cost) * 100"></div>
      </div>
      <!-- <p>{{ element.purchasedQty }} of {{ element.qty }} items purchased</p> -->
      <p>{{(element.purchasedTotal / element.cost) | percent}}</p>
      </span>


    <span  *ngIf="column == 'cost' || column == 'productPrice' || column == 'purchasedTotal'">
    {{ element[column]  | currency }}   
 </span>
 <span  *ngIf="column != 'cost' && column != 'productPrice'  && column != 'purchasedTotal'">
  {{ element[column] }}   
</span>
 


    <span  *ngIf="column == 'edit'">
    <button mat-icon-button (click)="editRow(element)" >
    <mat-icon>edit</mat-icon>
     </button>
   
     <button mat-icon-button (click)="removeMaterialfromProject(element)" >
      <mat-icon>delete</mat-icon>
       </button> 
   
    </span>

    
  </div>
  <ng-template #editCell>
     
    <span *ngIf="column != 'edit' && column != 'purchasedTotal' && column != 'total'">
      <label [innerText]="column"></label><br>
       <input [(ngModel)]="element[column]" title="save" (blur)="saveEdit(element)" />
       </span>
    <span *ngIf="column == 'edit'">
       <button mat-icon-button (click)="cancelEdit(element)">
      <mat-icon>done</mat-icon>
    </button>
    </span>
  </ng-template> 
</td>

  </ng-container>
  
  <tr mat-header-row *matHeaderRowDef="ProjectMaterialColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: ProjectMaterialColumns;"></tr>
</mat-table>
</span>
</span>
<span *ngIf="isMobile"> 
  <div *ngFor="let material of projectMaterials" class="card">
    <div class="card-content">
      <ng-container *ngIf="editedMaterial !== material; else editMaterialMobile">
        <div class="card-row">
          <span class="card-label"><b>Product Name:</b></span>
          <span class="card-value">{{ material.productName }}</span>
        </div>
        <div class="card-row"> 
          <span class="card-label"><b>Qty:</b></span>
          <span class="card-value">{{ material.qty }}</span>
          <span class="card-label" style="padding-left: 20px;"><b>Cost:</b></span>
          <span class="card-value">{{ material.productPrice | currency }}</span>
        </div>
        <div class="card-row">
          <span class="card-label"><b>Price:</b></span>
          <span class="card-value">
            {{ material.purchasedTotal | currency }} of {{ material.cost | currency }}
            <div class="progress-bar-container_mobile">
              <div class="progress-bar_mobile" [style.width.%]="(material.purchasedTotal / material.cost) * 100"></div>
            </div>
            <p>{{ (material.purchasedTotal / material.cost) | percent }}</p>
          </span>
        </div>
        <div class="card-row mt-2">
          <button class="mr-2 px-3 py-1 bg-yellow-100 text-yellow-800 rounded" (click)="editedMaterial = material">Edit</button>
          <button class="px-3 py-1 bg-red-100 text-red-700 rounded" (click)="removeMaterialfromProject(material)">Delete</button>
        </div>
      </ng-container>
      <ng-template #editMaterialMobile>
        <div class="card-row">
          <span class="card-label"><b>Product Name:</b></span>
          <input [(ngModel)]="material.productName" class="card-value border rounded px-2 py-1" />
        </div>
        <div class="card-row">
          <span class="card-label"><b>Qty:</b></span>
          <input type="number" [(ngModel)]="material.qty" class="card-value border rounded px-2 py-1" />
          <span class="card-label" style="padding-left: 20px;"><b>Cost:</b></span>
          <input type="number" [(ngModel)]="material.productPrice" class="card-value border rounded px-2 py-1" />
        </div>
        <!-- Add more fields as needed -->
        <div class="card-row mt-2">
          <button class="mr-2 px-3 py-1 bg-green-100 text-green-800 rounded" (click)="saveEdit(material)">Save</button>
          <button class="px-3 py-1 bg-gray-200 text-gray-800 rounded" (click)="editedMaterial = null">Cancel</button>
        </div>
      </ng-template>
    </div>
  </div>
</span>

      <!-- <table class="table table-striped table-sm">
 
 
    <thead>
      <tr> 
        <th><a (click)="sortBy('productName')">Product Name{{sortIcon('productName')}}</a></th>
        <th><a (click)="sortBy('productCategory')">Product Category{{sortIcon('productCategory')}}</a></th>
        <th><a (click)="sortBy('subCategory')">Sub Category{{sortIcon('subCategory')}}</a></th> 
        <th><a (click)="sortBy('productDescription')">Product Description{{sortIcon('productDescription')}}</a></th>
        <th><a (click)="sortBy('productPrice')">Product Price{{sortIcon('productPrice')}}</a></th> 
        <th><a (click)="sortBy('qty')">Qty{{sortIcon('qty')}}</a></th>
        <th><a (click)="sortBy('total')">Total{{sortIcon('total')}}</a></th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let material of project.materials"> 
        <td>{{ material.productName }}</td>
        <td>{{ material.productCategory }}</td>
        <td>{{ material.subCategory }}</td> 
        <td>{{ material.productDescription }}</td>
        <td>{{ material.productPrice }}</td> 
        <td>{{ material.qty }}</td>
        <td>{{ material.cost }}</td>  
        <td>{{ material.cost }}</td> <td>
          <button (click)="editMaterialinProject(material)">Edit</button>
        </td>
        <td>
          <button (click)="removeMaterialfromProject(material)">Remove</button>
        </td>
      </tr>
    </tbody>
  </table>
  -->



 
  </div>